import React from 'react';
import List from '@material-ui/core/List';
import Drawer from '@material-ui/core/Drawer';
import SidebarListItem from './sidebarListItem';
import { useTheme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import { useStyles } from '../Header/styles';
import SidebarListItemGroup from './sidebarListItemGroup';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { ClassNameMap } from '@material-ui/styles';
import { MENUITEMS } from './sidebarModel';
import Logo from '../../resources/images/Logo.png';
import { withRouter } from 'react-router-dom';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsAlt } from '@fortawesome/free-solid-svg-icons';

const Sidebar = (props: any) => {
   const { onClose, open, variant } = props;
   const theme = useTheme();
   const classes: ClassNameMap = useStyles();
   const routeToLocation = () => undefined;

   const itemsList = () =>
      MENUITEMS().map((item, index) => {
         if (!item.show) {
            return;
         }

         // in this case, we'll return itemGroup
         if (item.items) {
            return (
               <SidebarListItemGroup
                  key={index}
                  text={item.text}
                  onClick={routeToLocation}
                  icon={item.icon}
                  open={open}
                  variant={variant}
                  items={item.items}
               />
            );
         }

         // otherwise, we'll just return a list item
         return (
            <SidebarListItem
               key={index}
               text={item.text}
               icon={item.icon}
               items={item.items}
               variant={variant}
               open={open}
               onClick={routeToLocation}
               route={item.route}
            />
         );
      });

   const list = React.useMemo(() => itemsList(), [open, variant]);

   return (
      <Drawer
         // className={classes.drawer}
         variant={variant ? 'permanent' : 'temporary'}
         className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
         })}
         classes={{
            paper: clsx({
               [classes.drawerOpen]: open,
               [classes.drawerClose]: !open,
            }),
         }}
         // anchor="left"
         open={open}
         onClose={onClose}
         // classes={{
         //    paper: classes.drawerPaper,
         // }}
         style={{ position: 'relative' }}
      >
         <div className={classes.toolbar}>
            {!variant && (
               <>
                  <img src={Logo} alt="COMPANY lOGO" />
                  <IconButton onClick={onClose}>
                     {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                  </IconButton>
               </>
            )}
         </div>
         {variant && (
            <div
               role="button"
               tabIndex={0}
               onKeyDown={onClose}
               onClick={onClose}
               style={{
                  position: 'absolute',
                  top: '50px',
                  right: '0px',
                  borderLeft: '1px solid gainsboro',
                  borderBottom: '1px solid gainsboro',
                  // borderRadius: '5px',
                  padding: '3px',
                  cursor: 'pointer',
               }}
            >
               {/* <OpenWithIcon color="primary" fontSize="small" /> */}
               <FontAwesomeIcon icon={faArrowsAlt} color={theme.palette.primary.main} size="sm" />
            </div>
         )}
         {/* {open ? (
            
         ) : (
            <ChevronRightIcon onClick={onClose} style={{ position: 'absolute', top: '50px', right: '0px' }} />
         )} */}
         <List component="nav" className={classes.sidebar} style={{ marginTop: '10px' }}>
            {list}
         </List>
      </Drawer>
   );
};

export default withRouter(Sidebar);
